<button mat-button [matMenuTriggerFor]="nameAndDescriptioContextMenu">&#64;</button>
<mat-menu #nameAndDescriptioContextMenu="matMenu" class="menu-container">
    
          <div (click)="$event.stopPropagation();$event.preventDefault();">
            <form class="example-form">
                <mat-form-field class="example-full-width" appearance="fill">
                  <mat-label>User List</mat-label>
                  <input type="text"
                         placeholder="pick users"
                         aria-label="names"
                         matInput
                         [formControl]="myControl"
                         [matAutocomplete]="auto">
                  <mat-autocomplete #auto="matAutocomplete">
                    <mat-option *ngFor="let option of options" [value]="option">
                      <p class="vert-icon-p-tag">{{option}}</p>
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </form>  
          </div> 
</mat-menu>